import '../../httpservices/core/ajax.httpservice.core';

class KbSchedulingHttpService {

    CancerTypes() {
        return $.get('MskKb/Scheduler/CancerTypes');
    }

    InsuranceTypes() {
        return $.get('MskKb/Scheduler/InsuranceTypes');
    }

    DiagnosisTypes() {
        return $.get('MskKb/Scheduler/DiagnosisTypes');
    }

    NonPatientAppointmentRequest(data) {
        return $.post('MskKb/Scheduler/NonPatientAppointmentRequest', data);
    }

    // might don't need this since it only checks whether the user is MSK patient, but for patients, they won't see the self-scheduling tile
    IsAppointmentRequestPossible() {
        return $.get('MskKb/Scheduler/IsAppointmentRequestPossible');
    }
}

export const KbSchedulingHttpSvc = new KbSchedulingHttpService();